import { render, staticRenderFns } from "./CartReviewTicketOptionalProduct.vue?vue&type=template&id=dd98aa2e&scoped=true&"
import script from "./CartReviewTicketOptionalProduct.vue?vue&type=script&lang=ts&"
export * from "./CartReviewTicketOptionalProduct.vue?vue&type=script&lang=ts&"
import style0 from "./CartReviewTicketOptionalProduct.vue?vue&type=style&index=0&id=dd98aa2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd98aa2e",
  null
  
)

export default component.exports